import React from 'react'

type Cns = {
  container?: string
  box?: string
  item?: string
  activeItem?: string
}

export interface Nav {
  label: string
  anchor: string
}

export type NavigationProps = {
  lists: Nav[]
  styles?: {
    [key: string]: string
  }
  cns?: Cns
  offset?: number
  clickHandler?: (nav: Nav, index: number, e: React.MouseEvent<HTMLAnchorElement>) => void
}
